module.exports = __webpack_public_path__ + "img/mealdelivery.4246dffd.svg";